// src/features/risks/entities/unit/model/unit.thunks.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchBackend } from "@/core/apis/backend"
import unitStore from "./unit.store"
import establishmentStore from "@/features/adm/entities/establishment/model/establishment.store"
import { RootState } from "@/core/root-reducer"

// -----------------------------------------------------
// ASSOCIER DES JOBS À UNE UNITÉ
// PUT /unit/:unitId/jobs
// -----------------------------------------------------
export const setJobsForUnit = createAsyncThunk(
  "unit/setJobsForUnit",
  async ({ unitId, JobIds }: { unitId: string; JobIds: string[] }, { dispatch, getState }) => {
    const state = getState() as RootState
    const establishment = establishmentStore.selectors.active(state)

    const res = await fetchBackend({
      url: `/unit/${unitId}/jobs`,
      method: "PUT",
      data: {
        establishmentId: establishment.id,
        JobIds
      }
    })

    if (!res.error) {
      dispatch(unitStore.actions.replace(res))
    }

    return res
  }
)

// -----------------------------------------------------
// RECHARGER UNE UNIT AVEC SES JOBS
// (si besoin d’un load individuel)
// -----------------------------------------------------
export const fetchOneWithJobs = createAsyncThunk(
  "unit/fetchOneWithJobs",
  async (unitId: string, { dispatch, getState }) => {
    const state = getState() as RootState
    const establishment = establishmentStore.selectors.active(state)

    const res = await fetchBackend({
      url: `/unit/${unitId}`,
      method: "GET",
      data: {
        establishmentId: establishment.id
      }
    })

    if (!res.error) {
      dispatch(unitStore.actions.replace(res))
    }

    return res
  }
)
